import React from 'react';
import GallerySwiperReviewCardDesktop from './GallerySwiperReviewCardDesktop';
import GallerySwiperReviewCardMobile from './GallerySwiperReviewCardMobile';
import type { GallerySwiperReviewCardProps } from './types';

const GallerySwiperReviewCard = ({
  images,
  isMobile = true,
  title,
  className,
  disableOpenGallery,
}: GallerySwiperReviewCardProps) =>
  isMobile ? (
    <GallerySwiperReviewCardMobile
      images={images}
      title={title}
      disableOpenGallery={disableOpenGallery}
      className={className}
    />
  ) : (
    <GallerySwiperReviewCardDesktop
      images={images}
      title={title}
      className={className}
    />
  );

export default GallerySwiperReviewCard;
